import { Box, Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import {  courseOptions, intakeOptions , courses} from './data/data';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const defaultValues = {
  program: '',
  intake: '',
  course: '',
  startDate: '',
  endDate: '',
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    margin: '1rem 0',
    padding: theme.spacing(2),
    minHeight: '80vh',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.KenColors.kenWhite,

    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '300px',
    },

    '& .MuiButtonBase-root': {
      margin: theme.spacing(2),
    },
  },
  heading: {
    fontSize: 18,
    fontWeight: 700,
    color: '#061938',
    margin: 5,
  },
}));

const ProgramFilter = (props) => {
  const classes = useStyles();
  const [formValues, setFormValues] = useState(defaultValues);
  const [value, setValue] = React.useState('Online');

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFilters = () => {
    props.setFilters(formValues);
    props.setIsFiltered(true);
  };

  return (
    <Box className={classes.root}>
      <Grid container spacing={2} style={{ maxWidth: 400 }}>
        <Typography className={classes.heading}>Select Program</Typography>
        <Grid item xs={12}>
          <KenSelectWrap
            name="program"
            label="Program"
            options={courseOptions}
            value={formValues.program}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleInputChange(e)}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <KenSelectWrap
            name="intake"
            label="Intake"
            options={intakeOptions}
            value={formValues.intake}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleInputChange(e)}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <KenSelectWrap
            name="course"
            label="Course"
            options={courses  }
            value={formValues.course}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleInputChange(e)}
            required
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="gender"
              name="gender1"
              value={value}
              onChange={handleChange}
             style={{ display: 'block', alignItems: 'center' }}
              
            >
              {/* <FormLabel component="legend">Mode</FormLabel> */}
              <b style={{ marginRight: '80px'}}>Mode</b>
              <FormControlLabel
                value="online"
                control={<Radio />}
                label="Online"
                style={{ margin: 'auto' }}
              />
              <FormControlLabel
                value="offline"
                control={<Radio />}
                label="Offline"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <KenDateTimePicker
            name="startDate"
            label={'Start date'}
            value={formValues.startDate}
            type="date"
            required={true}
            defaultValue={formValues.startDate}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <KenDateTimePicker
            name="endDate"
            label="End date"
            value={formValues.endDate}
            type="date"
            required={true}
            defaultValue={formValues.endDate}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          <Button variant="outlined" onClick={handleFilters}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilters}
            style={{ margin: '16px 0' }}
          >
            Select
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProgramFilter;